import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Selon les pages, le défilement se fait sur window, documentElement ou body.
    // On les remet tous à zéro, et on répète après le rendu (rAF + timeout) car la
    // nouvelle page peut se mettre en page après l'exécution de cet effet.
    const reset = () => {
      try { window.scrollTo(0, 0); } catch { /* noop */ }
      if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };
    reset();
    const raf = requestAnimationFrame(reset);
    const tm = setTimeout(reset, 80);
    return () => { cancelAnimationFrame(raf); clearTimeout(tm); };
  }, [pathname]);
  return null;
}
